module.exports = __webpack_public_path__ + "img/progressico.fc1ff963.png";